module.exports = __webpack_public_path__ + "static/media/6.ee236aab.png";